import { apiClient } from './api';

export interface MenuItem {
  id: string;
  title: string;
  link?: string;
  icon?: string;
  target: '_self' | '_blank';
  parent_id?: string;
  ordering: number;
  item_type?: 'custom' | 'page' | 'article' | 'category' | 'product' | 'product_category' | 'text';
  item_id?: string;
  children?: MenuItem[];
}

export interface Menu {
  _id: string;
  title: string;
  description?: string;
  slug: string;
  alias?: string;
  state: number;
  position: string[];
  ordering: number;
  items: MenuItem[];
  collection_slug?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateMenuDto {
  title: string;
  description?: string;
  slug?: string;
  state?: number;
  position?: string[];
  ordering?: number;
  items?: MenuItem[];
  collection?: string;
}

export interface UpdateMenuDto extends CreateMenuDto {}

export interface MenuFilters {
  page?: number;
  limit?: number;
  q?: string;
  state?: number;
  created_at?: string;
  collection_slug?: string;
  sort?: string;
  order?: string;
}

export interface MenusResponse {
  data: Menu[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const menuService = {
  getMenus: async (filters: MenuFilters = {}): Promise<MenusResponse> => {
    const response = await apiClient.get('/menus', { params: filters });
    return response.data.data;
  },

  getMenuById: async (id: string): Promise<Menu> => {
    const response = await apiClient.get(`/menus/${id}`);
    return response.data.data;
  },

  createMenu: async (data: CreateMenuDto): Promise<Menu> => {
    const response = await apiClient.post('/menus', data);
    return response.data.data;
  },

  updateMenu: async (id: string, data: UpdateMenuDto): Promise<Menu> => {
    const response = await apiClient.put(`/menus/${id}`, data);
    return response.data.data;
  },

  deleteMenus: async (ids: string[]): Promise<{ deleted: number }> => {
    const response = await apiClient.delete('/menus', { data: { ids } });
    return response.data.data;
  },
};

export default menuService;
